<template lang="pug">
ul.list-group.placement-dropdown(:class="{ opened: opened }")
  Placement(:placement="placement")
    a.open(@click="openedValue = !openedValue")
      i.fa(:class="{ 'fa-angle-down': !opened, 'fa-angle-up': opened }")
  .placement-dropdown-dropdown
    div(
      v-for="pub in publications"
      v-if="opened && publicationIssues(pub).length > 0"
      :key="pub.id"
    )
      li.list-group-item.disabled
        strong {{ pub.name }}
      template(v-for="issue in publicationIssues(pub)")
        IssueRow(v-model="inputValue" :issue="issue")
        PageRow(
          v-for="page in pagesStore.forIssue(issue)"
          v-if="issueId === issue.id"
          v-model="inputValue"
          :page="page"
          :key="page.id"
        )
</template>

<script>
  import { sync } from 'vuex-pathify'
  import { mapStores, mapState } from 'pinia'
  import { usePagesStore } from '@/stores/pages'
  import { usePublicationsStore } from '@/stores/publications'
  import { useIssuesStore } from '@/stores/issues'
  import Placement from '@/components/stories/placement/index.vue'
  import IssueRow from './issue_row.vue'
  import PageRow from './page_row.vue'

  export default {
    components: {
      Placement,
      IssueRow,
      PageRow
    },

    props: {
      value: {
        type: Object,
        required: true
      },
      opened: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapStores(useIssuesStore, usePagesStore, usePublicationsStore),
      ...mapState(usePublicationsStore, ['publications']),
      placement() { return this.value },
      issueId() { return this.placement.issue_id },
      pageId() { return this.placement.page_id },
      inputValue: {
        get() { return this.value },
        set(val) { this.$emit('input', val) }
      },
      openedValue: {
        get() { return this.opened },
        set(val) { this.$emit('opened', val) }
      }
    },

    watch: {
      open(opened) {
        if(opened && this.issueId) {
          this.pagesStore.fetchOnce({ issueId: this.issueId })
        }
      },

      value(newVal, oldVal) {
        const issueId = newVal.issue_id

        if(issueId && issueId !== oldVal.issue_id) {
          this.pagesStore.fetchOnce({ issueId })
        }
      }
    },

    methods: {
      publicationIssues(pub) {
        return this.issuesStore.forPublication(pub)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .placement-dropdown {
    position: relative;

    a.open {
      float: right;
      cursor: pointer;
    }

    &.opened .placement-dropdown-dropdown {
      position: absolute;
      width: 100%;
      z-index: 100;
      box-shadow: 3px 3px 5px #ddd;
    }
  }
</style>
